import React, { useEffect, useState } from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import useMediaQuery from "../../hooks/haiku/useMediaQuery";
import { ReactComponent as IconAnchorLeft18 } from "../../icons/icon/18/a-icon-anchor-left-18.svg";
import { ReactComponent as IconAnchorRight18 } from "../../icons/icon/18/a-icon-anchor-right-18.svg";
import LinkButton from "../button/linkButton";

import "./mediaGallerySection.scss";

const MediaGallerySlider = ({
  children,
  title = null,
}) => {
  const [prevDisabled, setPrevDisabled] = useState(true);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [swiper, setSwiper] = useState(null);

  const isLargerEqualXl = useMediaQuery("(min-width: 1200px)", false);

  const checkButtons = () => {
    if (swiper) {
      setNextDisabled(swiper.isEnd);
      setPrevDisabled(swiper.isBeginning);
    }
  };

  useEffect(() => {
    checkButtons();
  }, []);

  const next = () => {
    swiper?.slideNext();
  };

  const previous = () => {
    swiper?.slidePrev();
  };

  return (
    <div className="media-gallery">
      <div className="media-gallery__content media-gallery-slider">
        <div className="media-gallery-slider__title">{title}</div>
        <Swiper
          onSwiper={setSwiper}
          slidesPerView="auto"
          keyboard
          mousewheel={{ forceToAxis: true }}
          onSlideChange={checkButtons}
          spaceBetween={30}
          modules={[Pagination]}
          pagination={{
            bulletActiveClass: "active",
            bulletClass: "swiper-bullet-pagination",
            clickable: true,
            renderBullet: (index, name) => `<div class="${name}"></div>`,
          }}
        >
          {React.Children.map(children, (child) => (
            <SwiperSlide key={child.key}>
              {child}
            </SwiperSlide>
          ))}
        </Swiper>

        {isLargerEqualXl && (
          <div className="media-gallery-slider__control">
            <LinkButton
              disabled={prevDisabled}
              variant="normal"
              onClick={previous}
            >
              <IconAnchorLeft18 />
              <FormattedMessage id="cardslider.previous" />
            </LinkButton>
            <LinkButton
              disabled={nextDisabled}
              variant="normal"
              onClick={next}
            >
              <FormattedMessage id="cardslider.next" />
              <IconAnchorRight18 />
            </LinkButton>
          </div>
        )}
      </div>
    </div>
  );
};

MediaGallerySlider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  title: PropTypes.string,
};

export default MediaGallerySlider;
